import React, { Component } from 'react'

import { SettingsRowEmpty } from '../StyledComponents/Settings'


class SettingsEmptyRow extends Component {
    render() {
        return <SettingsRowEmpty />
    }
}

export default SettingsEmptyRow



// WEBPACK FOOTER //
// ./src/components/Settings/SettingsEmptyRow.js